import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DialogConfig } from '../dialog-config';
import { DialogRef } from '../dialog-ref';
@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertComponent implements OnInit {
  action:string = 'alert';
  title: string = "";
  description: string = "";
  btnText: string = "";
  btnCancel:string = '';
  btnConfirm:string = '';
  constructor(private config: DialogConfig, private ref: DialogRef) { }

  ngOnInit() {

    if(this.config.data.action){
      this.action = this.config.data.action;
    }

    if(this.config.data.title){
      this.title = this.config.data.title;
    }
    if(this.config.data.description){
      this.description = this.config.data.description;
    }
    if(this.config.data.btnText){
      this.btnText = this.config.data.btnText;
    }
    if(this.config.data.btnConfirm){
      this.btnConfirm = this.config.data.btnConfirm;
    }
    if(this.config.data.btnCancel){
      this.btnCancel = this.config.data.btnCancel;
    }

  }

  onClose(status:boolean =true) {
    this.ref.close(status);
  }

}
